import { Component } from '@angular/core';

interface FAQCol {
  id: string,
  items: FAQItem[];
}

interface FAQItem {
  id: string,
  title: string,
  content: string,
  isExpanded: boolean
}

@Component({
  selector: 'app-product-list-faq',
  templateUrl: './product-list-faq.component.html',
  styleUrl: './product-list-faq.component.css',
})
export class ProductListFaqComponent {

  faqItemsSx: FAQItem[] = [
    {
      id: 'periodoDetenzioneRaccomandato',
      title: 'Periodo di detenzione raccomandato',
      content: "È il numero di anni che l'emittente assicurativo indica nel KID, il documento informativo sintetico obbligatorio, come periodo minimo ideale per fruire dei potenziali vantaggi finanziari insiti nella polizza.",
      isExpanded: false
    },
    {
      id: 'costoAnnuo',
      title: 'Costo annuo (per il periodo di detenzione raccomandato)',
      content: "Indica il costo omnicomprensivo annuo del prodotto calcolato dall'emittente per la durata del periodo di detenzione raccomandato, comprensivo del costo dell'eventuale riscatto anticipato se l'assicurazione vita ha scadenza più lontana. Tale costo ha l'effetto di diminuire della stessa percentuale il rendimento annuo lordo del capitale investito nelle attività finanziarie indicate nel contratto di polizza. <br>Periodi di detenzione inferiori a quello raccomandato, esercitando prima il riscatto, danno luogo a un costo annuo superiore, mentre periodi di detenzione più lunghi possono dare luogo a un costo annuo inferiore.",
      isExpanded: false
    },
    {
      id: 'Rendimenti attesi',
      title: 'Rendimenti attesi',
      content: "Sono i rendimenti annui futuri, al netto di tutti i costi di cui al punto sopra, stimati dall'emittente per il periodo di detenzione minima raccomandato, come indicato nel KID. Il documento informativo sintetico riporta il rendimento netto annuo stimato in quattro diversi scenari dei mercati finanziari oggetto d'investimento del capitale: </br><ul> <li><b>Scenario moderato:</b> costituisce lo scenario positivo più verosimile, da assumere indicativamente come rendimento di riferimento per il raffronto con altre polizze con caratteristiche analoghe.</li><li><b>Scenario favorevole:</b> è una stima del rendimento annuo a cui il sottoscrittore può aspirare in caso di andamento ampiamente positivo dei mercati finanziari in cui investe la polizza.</li><li><b>Scenario sfavorevole:</b> indica la perdita da mettere in conto durante uno o più anni negativi nell'ambito del periodo di detenzione minima raccomandata dall'emittente.</li><li><b>Scenario di stress:</b> rappresenta la perdita verosimilmente massima a cui il sottoscrittore può andare incontro in un anno particolarmente negativo per i mercati finanziari in cui investe la polizza.</li></ul> ",
      isExpanded: false
    },

    {
      id: 'obiettivoInvestimento',
      title: 'Obiettivo investimento',
      content: "In funzione della tipologia/rischiosità degli investimenti sottostanti la polizza vita, a cui è demandata la possibilità di rivalutazione del capitale, l'obiettivo della gestione finanziaria del prodotto può essere: <br><b>1) Conservazione del capitale</b>, che rappresenta la gestione meno rischiosa del capitale conferito, anche al costo di conseguire un rendimento inferiore all'inflazione. <br><b>2) Reddito</b>, dove il profilo di rendimento-rischio è quello di una gestione obbligazionaria in titoli di Stato italiani. <br><b>3) Incremento del capitale</b>, che identifica una gestione finanziaria orientata a produrre rendimenti superiori a quelli obbligazionari, prevalentemente tramite investimenti di tipo azionario, a cui corrisponde una maggiore rischiosità in termini di possibile deterioramento del capitale in caso in caso di scenari avversi per i mercati azionari; questa possibilità risulta tanto più bassa quanto più lontana è la scadenza della polizza.",
      isExpanded: false
    },
  
  ];

  faqItemsDx: FAQItem[] = [
    // {
    //   id: 'etichette',
    //   title: 'Le tre etichette della tabella',
    //   content: "I prodotti assicurativi che soddisfano le caratteristiche della presente ricerca sono confrontabili nell’ambito di ognuno dei tre ambiti d’indagine affrontati nelle domande a cui hai risposto: Caratteristiche generali, Coperture assicurative e Prestazioni finanziarie; clicca sulle etichette per raffrontare in dettaglio le polizze vita che soddisfano i tuoi criteri di ricerca.",
    //   isExpanded: false
    // },
    {
      id: 'gradoDiRischio',
      title: 'Grado di rischio',
      content: "Il KID, il documento informativo sintetico obbligatorio, riporta la scala di rischio (da 1 a 7) in cui si può collocare ogni prodotto finanziario, in questo caso la polizza assicurativa. Per alcune polizze vita è possibile rilevare nel KID una fascia di rischio (es. da 2 a 4), anziché un unico valore: si tratta di prodotti che prevedono combinazioni flessibili in termini di tipologia di investimenti a cui è demandata la rivalutazione del capitale; perciò, la stessa polizza può assumere rischiosità differenti in base alla scelta e quindi alla propensione al rischio del contraente. <br>Normalmente, a un rischio più elevato corrisponde una probabilità maggiore di conseguire rivalutazioni del capitale più consistenti, associate però a un rischio crescente di registrare rivalutazioni nulle o perfino negative in caso avverso. Un rischio più basso è invece compatibile con rivalutazioni più contenute, ma meno incerte.",
      isExpanded: false
    },
    {
      id: 'ordinamento',
      title: 'Ordinamento del risultato e dettaglio prodotti',
      content: "Il risultato della ricerca è ordinabile per ciascuna colonna che trovi nella tabella: posizionandoti con il cursore su ogni intestazione di colonna apparirà una freccia che, cliccandola, consentirà di ordinare il risultato della ricerca in ordine crescente dei valori riportati nella stessa colonna (freccia su) oppure in ordine decrescente (freccia giù). Per accedere al dettaglio prodotto è sufficiente cliccare sul nome del prodotto stesso contenuto nella prima colonna.",
      isExpanded: false
    },

    {
      id: 'filtri',
      title: 'Utilizzo dei filtri',
      content: "Puoi restringere ulteriormente il risultato della presente ricerca e comparazione filtrando le polizze vita risultanti in tabella attraverso cinque diversi criteri di filtraggio attivabili in testa alla pagina: puoi utilizzarne uno o più di uno simultaneamente, in base alla caratteristica o alle caratteristiche dei prodotti presenti in tabella su cui ti vuoi focalizzare. Dopodiché, se deciderai di disattivarli, l'elenco in tabella tornerà a essere quello originario che ha soddisfatto le tue risposte.",
      isExpanded: false
    },

    /*
    {
      id: 'modifica',
      title: 'Modifica delle risposte',
      content: "Per modificare una o più risposte alle domande che hanno condotto al presente risultato della ricerca hai a disposizione due strade: 1) puoi cliccare sugli istogrammi orizzontali blu che riportano (in rosso) la quantità di prodotti disponibili in funzione di ogni risposta fornita; 2) puoi cliccare la barra orizzontale posta in alto che riporta le tre aree tematiche delle domande (Caratteristiche generali, Coperture assicurative, Prestazioni finanziarie), scorrendole poi a tuo piacimento.",
      isExpanded: false
    },
    */
    {
      id: 'salvataggio',
      title: 'Salvataggio ricerca e prodotti',
      content: "Puoi salvare in ogni momento questo risultato della ricerca, nominandolo a tuo piacimento, in modo da poterlo riaprire quando vuoi e poterlo confrontare con altri tipi di ricerca, rispondendo in modo diverso a una o più domande. Così come puoi salvare uno o più prodotti assicurativi di tuo interesse accedendo al relativo dettaglio, ovvero cliccando sul nome contenuto nella prima colonna. In entrambi i casi è necessario che ti registri per poter disporre del tuo account personale. La registrazione è sempre gratuita.",
      isExpanded: false
    }
  ];

  faqCols: FAQCol[] = [
    {
      id: 'itemsSx',
      items: this.faqItemsSx
    },
    {
      id: 'itemsDx',
      items: this.faqItemsDx
    }
  ];

}
